/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StudenteFilterForm { 
    /**
     * nominativo studente o genitore (cerca in nome e cognome)
     */
    nominativo?: string;
    /**
     * codice pratica
     */
    codicePratica?: string;
    /**
     * nome scuola
     */
    nomeScuola?: string;
    /**
     * plesso scuola
     */
    plessoScuola?: string;
    /**
     * sezione
     */
    sezione?: string;
    /**
     * classe
     */
    classe?: string;
    /**
     * pasti residui maggiori uguali di
     */
    pastiResiduiMaggioriDi?: number;
    /**
     * pasti residui minori uguali di
     */
    pastiResiduiMinoriDi?: number;
    /**
     * dieta alternativa
     */
    dietaAlternativa?: string;
    /**
     * esente dal pagamento del pasto
     */
    isEsente?: boolean;
    /**
     * sospeso dal servizio mensa
     */
    isSospeso?: boolean;
}